import Axios from 'axios'
import { defineStore } from 'pinia'
import { GpvRepository } from '@/repositories/gpv-repository'

const storeKey = 'gpv'

type ForcastTimeData = {
  baseTime: string
  forecastTimes: string[]
}

type Store = {
  loading: boolean
  baseTime: string
  forecastTime: string
  dojou?: ForcastTimeData
  dosha?: ForcastTimeData
  nowcast?: ForcastTimeData
  srf?: ForcastTimeData
  status: number
}

const repository = new GpvRepository()

export const useGpvStore = defineStore(storeKey, {
  state: () =>
    ({
      loading: true,
      baseTime: '',
      forecastTime: '',
      dojou: undefined,
      dosha: undefined,
      nowcast: undefined,
      srf: undefined,
      status: 200,
    } as Store),

  getters: {
    success: state => {
      return state.status === 200
    },
  },

  actions: {
    setBaseTime(baseTime: string) {
      this.baseTime = baseTime
    },
    setForcastTime(forecastTime: string) {
      this.forecastTime = forecastTime
    },
    async fetchTime() {
      try {
        const res = await repository.getTime()

        this.dojou = res.dojou
        this.dosha = res.dosha
        this.nowcast = res.nowcast
        this.srf = res.srf
      } catch (e) {
        if (Axios.isAxiosError(e) && e.response) {
          this.status = e.response.status
        } else {
          this.status = 500
        }
      }

      this.loading = false
    },
  },
})
